/**
 * Country the platform falls back to whenever none is resolved, either because
 * a caller omitted it or because the account has no country on record.
 */
export const DEFAULT_COUNTRY_ISO2 = 'CL';

export const COUNTRY_ISO2 = {
  CL: 'CL',
  MX: 'MX',
};

/**
 * Applies the fallback to a country argument. Used wherever a caller may omit
 * it, so the thunk and its `condition` agree on the same key.
 *
 * @param {string} [iso2]
 * @returns {string}
 */
export const resolveCountryIso2 = (iso2) => iso2 || DEFAULT_COUNTRY_ISO2;
